import React, { useEffect } from "react";
import Navigation from "@/scenes/demo/components/navigation";
import Sections from "@/scenes/demo/components/sections";
import { useGenericContext } from "@/context/generic";
import { IS_SERVER } from "@/helpers/CompileHelper";
import useEventListener from "@/hooks/EventListener";
import Loader from "@/components/help/loader";
import { QUESTIONS } from "@/scenes/bestridte-krav/data/questions";
import useApi from "@/synega/hooks/useApi";
import useUpdateEffect from "@/hooks/UpdateEffect";

const ContestedClaims = (props) => {
    const api = useApi();
    const context = useGenericContext();
    const { state, simpleDispatch } = context;

    useEffect(() => {
        if (IS_SERVER) return;

        if (state?.step?.current >= 0) {
            setFunctions();
        } else {
            onReset();
        }
    }, [])

    useUpdateEffect(() => {
        if (IS_SERVER) return;
        if (state?.funnel?.submitting == null) return;
        if ((state?.step?.current ?? 0) <= 0) return;

        if (state?.funnel?.submitting || state?.funnel?.submitted) {
            simpleDispatch({
                step: {
                    direction: 1,
                    previous: state.step.current,
                    current: state.step.current + 1,
                },
            })
        } else {
            simpleDispatch({
                step: {
                    direction: -1,
                    previous: state.step.current,
                    current: state.step.current - 1,
                },
            })
        }
    }, [state?.funnel?.submitting])

    const setFunctions = () => {
        simpleDispatch({
            functions: {
                onSubmit,
                onReset,
            },
            funnel: {
                submitting: null,
                // submitted: false // uncomment only in development
            },
            step: {
                // current: 0, // uncomment only in development
            },
        })
    }

    const onReset = () => {
        simpleDispatch({
            funnel: {
                submitted: false,
                submitting: false,
            },
            step: {
                direction: 0,
                current: 0,
                previous: 0,
                max: 2,
            },
        })
        setFunctions();
    }

    const onSubmit = () => {
        let submitEvent = new CustomEvent("_submit", {
            bubbles: true,
        })
        document.dispatchEvent(submitEvent)
    }

    const submit = () => {
        if (state.funnel.submitting) return;

        simpleDispatch({ funnel: { submitting: true }})
        let part_phone = state.funnel.part_phone?.replace(/\s/g, "") ?? "";
        let part_email = state.funnel.part_email?.replace(/\s/g, "") ?? "";
        let question = QUESTIONS.find(item => item.pkey === "where_did_you_find_us")
        let partner_company = question?.options?.find?.(item => item.label === state.funnel.where_did_you_find_us);

        let payload = {
            name: state.funnel.business_name,
            email: state.funnel.contact_email,
            phone: {
                number: state.funnel.contact_phone,
                dial_code: "47",
            },
            form: "PARTNER",
            contact: {
                name: state.funnel.contact_name,
                email: state.funnel.contact_email,
                phone: {
                    number: state.funnel.contact_phone,
                    dial_code: "47",
                },
            },
            partner: {
                company: partner_company,
            },
            miscellaneous: {
                sum: state.funnel.sum,
                reason: state.funnel.reason,
                source: state.funnel.where_did_you_find_us,
            },
            counterpart: {
                has: state.funnel.has_contact_info?.value,
                name: state.funnel.part_name,
                phone: {
                    valid: part_phone.length === "92929292".length,
                    value: {
                        country: "NO",
                        dial_code: "47",
                        number: part_phone,
                        "e.164": `+47${part_phone}`,
                    },
                },
                email: {
                    valid: part_email.match(/[@]/g)?.join("").length === 1 && part_email.length > 5,
                    value: part_email,
                },
            },
        }
        api.post("/leads/contested-claims", payload).then(res => {
            if (res?.status === "success") {
                simpleDispatch({ funnel: { submitting: false, submitted: true }})
            } else {
                simpleDispatch({ funnel: { submitting: false }})
            }
        }).catch(error => {
            console.warn(error?.response?.data?.messages);
            simpleDispatch({ funnel: { submitting: false }})
        })
    }
    useEventListener("_submit", submit);

    return (
        <>
            <Loader loading={state.funnel?.submitting}/>
            <main className="mt-14">
                <section className="content-small">
                    <Sections/>
                </section>
            </main>

            <Navigation/>
        </>
    );
};

export default ContestedClaims;
